/*=========================================================================================
  File Name: moduleAuthGetters.js
  Description: Auth Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  isLoggedIn: state => !!state.token,
  authStatus: state => state.status,
  userInfo: state => state.userInfo,
  checkOtp: state => state.checkOtp,
  config: state => state.config,
  idDomain: state => state.idDomain,
  mercure: state => state.mercure,
  userSigninInfo: state => state.userSigninInfo,
  userInfoError: state => state.userInfoError
}
